import { cn } from "@/lib/utils";

const OUTLINE = "12,1.5 17.2,9 19.5,14.5 18,19.2 12,22.5 6,19.2 4.5,14.5 6.8,9";

// Gem-cut facets, lit from the top-left: light crown, deep right pavilion.
const FACETS = [
  { points: "12,1.5 6.8,9 8.4,14 12,9.5", fill: "fill-sky-200" },
  { points: "12,1.5 12,9.5 15.6,14 17.2,9", fill: "fill-sky-300" },
  { points: "6.8,9 4.5,14.5 8.4,14", fill: "fill-sky-300" },
  { points: "17.2,9 15.6,14 19.5,14.5", fill: "fill-sky-500" },
  { points: "4.5,14.5 6,19.2 12,22.5 12,19 8.4,14", fill: "fill-sky-400" },
  { points: "19.5,14.5 15.6,14 12,19 12,22.5 18,19.2", fill: "fill-sky-600" },
  { points: "12,9.5 15.6,14 12,19 8.4,14", fill: "fill-sky-100" },
];

// Faceted crystal drop marking liquid jobs on the leaderboard.
export const LeaderboardCrystalDrop = ({
  className,
}: {
  className?: string;
}) => (
  <svg
    className={cn("h-[18px] w-[18px] shrink-0", className)}
    viewBox="0 0 24 24"
  >
    {FACETS.map((facet) => (
      <polygon
        key={facet.points}
        className={cn(facet.fill, "stroke-white/70")}
        points={facet.points}
        strokeLinejoin="round"
        strokeWidth="0.4"
      />
    ))}
    <polygon
      className="fill-none stroke-sky-700"
      points={OUTLINE}
      strokeLinejoin="round"
      strokeWidth="0.8"
    />
  </svg>
);
